import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _typeof from "@babel/runtime/helpers/typeof";
import _awaitAsyncGenerator from "@babel/runtime/helpers/awaitAsyncGenerator";
import _wrapAsyncGenerator from "@babel/runtime/helpers/wrapAsyncGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import partition from 'lodash/partition';
import { sliceOrNodeToMarkdown } from '../../config-items/slice-or-node-to-markdown';
import { MAX_PARTS, PART_MAX_SIZE, QUEUE_MAX_ADDITIONAL_ATTEMPTS, TOTAL_PARTS_MAX_SIZE } from './constants';

/**
 * When updating this type, please update the corresponding type guard functions too
 */

function isValidStreamingResponse(response) {
  return _typeof(response) === 'object' && response !== null && 'id' in response && ('part' in response || 'error' in response);
}
var getParagraphChunkWithMDPlus = function getParagraphChunkWithMDPlus(doc, editorView, chunk) {
  var chunkIdMap = {};
  var from = chunk.from,
    to = chunk.to;
  var slice = doc.slice(from, to);
  if (!slice) {
    return;
  }
  var _sliceOrNodeToMarkdow = sliceOrNodeToMarkdown({
      editorView: editorView,
      slice: slice,
      convertTo: 'markdown-plus',
      updateIdMap: function updateIdMap(_ref) {
        var idMap = _ref.idMap;
        chunkIdMap = idMap;
      },
      selectionType: 'range'
    }),
    markdown = _sliceOrNodeToMarkdow.markdown;
  return _objectSpread(_objectSpread({}, chunk), {}, {
    markdown: markdown,
    chunkIdMap: chunkIdMap
  });
};
function parseResponse(queue, response) {
  var chunk = queue.find(function (p) {
    return (response === null || response === void 0 ? void 0 : response.id) === p.id;
  });
  if (!chunk || !isValidStreamingResponse(response)) {
    return {
      result: false,
      error: 'Invalid streaming response',
      // It may be possible that id is in response but part or error does not exist.
      chunkId: response.id
    };
  }
  if ('error' in response) {
    return {
      result: false,
      error: 'part was missing in reponse.',
      chunkId: chunk.id
    };
  }
  return {
    result: true,
    response: _objectSpread({
      chunkId: chunk.id,
      suggestion: response.part,
      chunkIdMap: chunk.chunkIdMap
    }, response.metadata && {
      metadata: {
        editDistanceRatio: Number(response.metadata.edit_distance_ratio) || undefined,
        wordCountRatio: Number(response.metadata.word_count_ratio) || undefined,
        originalContentLength: Number(response.metadata.original_content_length) || undefined
      }
    })
  };
}
export function mdPlusSuggestionGenerator(_x) {
  return _mdPlusSuggestionGenerator.apply(this, arguments);
}
function _mdPlusSuggestionGenerator() {
  _mdPlusSuggestionGenerator = _wrapAsyncGenerator(function (_ref2) {
    var endpoint = _ref2.endpoint,
      paragraphs = _ref2.paragraphs,
      editorView = _ref2.editorView;
    return /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var doc, abortController, purgedChunkIds, totalParts, attemptCount, _partition, _partition2, withinLimitsParagraphChunks, exceededLimitsParagraphChunks, _loop, _ret;
      return _regeneratorRuntime.wrap(function _callee$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (paragraphs.length) {
              _context2.next = 4;
              break;
            }
            _context2.next = 3;
            return {
              state: 'done'
            };
          case 3:
            return _context2.abrupt("return");
          case 4:
            /**
             * QUEUE CONSTRAINTS:
             * Input size sum (all parts): 10,000 chars
             * Input size per part: 5,000 chars
             * Max parts: 50
             */
            doc = editorView.state.doc;
            abortController = new AbortController();
            purgedChunkIds = [];
            totalParts = paragraphs.length;
            attemptCount = 0; // Partition into parts that are within the part size limit and parts that exceed it
            // This is done due to backend limitations
            _partition = partition(paragraphs, function (p) {
              return p.text.length <= PART_MAX_SIZE;
            }), _partition2 = _slicedToArray(_partition, 2), withinLimitsParagraphChunks = _partition2[0], exceededLimitsParagraphChunks = _partition2[1]; // For all parts that exceed the parts limit, add them to the purged list
            purgedChunkIds.push.apply(purgedChunkIds, _toConsumableArray(exceededLimitsParagraphChunks.map(function (p) {
              return p.id;
            })));
            _loop = /*#__PURE__*/_regeneratorRuntime.mark(function _loop() {
              var queue, queueTotalPartsSize, withinLimitsParagraphChunk, paragraphChunkWithMDPlus, queuedChunkIds, requests, payload, startTime, response, processedChunkIds, reader, decoder, lineBuffer, done, _yield$_awaitAsyncGen, value, doneReading, chunkValue, lines, suggestions, errors, failedChunkIds, line, parsedData, parsedResponse, _parsedResponse$respo, chunkId, metadata;
              return _regeneratorRuntime.wrap(function _loop$(_context) {
                while (1) switch (_context.prev = _context.next) {
                  case 0:
                    attemptCount++;
                    queue = []; // const queue = new Map<ParagraphChunk['id'], ParagraphChunk['text']>();
                    queueTotalPartsSize = 0;
                    /**
                     * Fill the queue with parts up until the constraints have been met or until all parts have been added
                     */
                  case 3:
                    if (!(withinLimitsParagraphChunks.length && queueTotalPartsSize + withinLimitsParagraphChunks[0].text.length <= TOTAL_PARTS_MAX_SIZE && queue.length <= MAX_PARTS)) {
                      _context.next = 12;
                      break;
                    }
                    withinLimitsParagraphChunk = withinLimitsParagraphChunks.shift();
                    if (withinLimitsParagraphChunk) {
                      _context.next = 7;
                      break;
                    }
                    return _context.abrupt("break", 12);
                  case 7:
                    queueTotalPartsSize += withinLimitsParagraphChunk.text.length;
                    paragraphChunkWithMDPlus = getParagraphChunkWithMDPlus(doc, editorView, withinLimitsParagraphChunk);
                    if (paragraphChunkWithMDPlus) {
                      queue.push(paragraphChunkWithMDPlus);
                    }
                    _context.next = 3;
                    break;
                  case 12:
                    if (queue.length) {
                      _context.next = 14;
                      break;
                    }
                    return _context.abrupt("return", 0);
                  case 14:
                    queuedChunkIds = queue.map(function (p) {
                      return p.id;
                    });
                    _context.prev = 15;
                    /**
                     * API Spec documented at https://hello.atlassian.net/wiki/spaces/CA3/pages/3776161653/Bulk+Spelling+and+Grammar+Endpoint
                     */
                    requests = {}; // Only add uncached paragraphs to requests, since cached ones have already been yielded
                    queue.forEach(function (chunk) {
                      requests[chunk.id] = chunk.markdown;
                    });
                    payload = {
                      requests: requests
                    }; // track durations
                    startTime = performance.now();
                    _context.next = 22;
                    return _awaitAsyncGenerator(fetch(endpoint, {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json;charset=UTF-8'
                      },
                      body: JSON.stringify(payload),
                      credentials: 'include',
                      signal: abortController.signal,
                      mode: 'cors'
                    }));
                  case 22:
                    response = _context.sent;
                    _context.next = 25;
                    return {
                      state: 'trackedDuration',
                      duration: performance.now() - startTime
                    };
                  case 25:
                    if (response.ok) {
                      _context.next = 29;
                      break;
                    }
                    _context.next = 28;
                    return {
                      state: 'failed',
                      reason: 'backend',
                      errors: ["unexpected response status: ".concat(response.status)],
                      statusCode: response.status,
                      failedChunkIds: queuedChunkIds
                    };
                  case 28:
                    return _context.abrupt("return", 0);
                  case 29:
                    if (response.body) {
                      _context.next = 33;
                      break;
                    }
                    _context.next = 32;
                    return {
                      state: 'failed',
                      reason: 'network',
                      errors: ['response.body missing'],
                      statusCode: response.status,
                      failedChunkIds: queuedChunkIds
                    };
                  case 32:
                    return _context.abrupt("return", 0);
                  case 33:
                    processedChunkIds = [];
                    _context.prev = 34;
                    reader = response.body.getReader();
                    decoder = new TextDecoder('utf-8');
                    lineBuffer = '';
                    done = false;
                  case 39:
                    if (done) {
                      _context.next = 78;
                      break;
                    }
                    _context.next = 42;
                    return _awaitAsyncGenerator(reader.read());
                  case 42:
                    _yield$_awaitAsyncGen = _context.sent;
                    value = _yield$_awaitAsyncGen.value;
                    doneReading = _yield$_awaitAsyncGen.done;
                    done = doneReading;
                    chunkValue = decoder.decode(value);
                    lineBuffer = lineBuffer + chunkValue;
                    // Split the lineBuffer by line breaks
                    lines = lineBuffer.split('\n'); // Process all complete lines, except for the last one (which might be incomplete)
                    suggestions = [];
                    errors = [];
                    failedChunkIds = [];
                  case 52:
                    if (!(lines.length > 1)) {
                      _context.next = 69;
                      break;
                    }
                    line = lines.shift();
                    parsedData = JSON.parse(line);
                    parsedResponse = parseResponse(queue, parsedData);
                    if (!parsedResponse.result) {
                      _context.next = 65;
                      break;
                    }
                    _parsedResponse$respo = parsedResponse.response, chunkId = _parsedResponse$respo.chunkId, metadata = _parsedResponse$respo.metadata;
                    suggestions.push(parsedResponse.response);
                    processedChunkIds.push(chunkId);
                    if (!metadata) {
                      _context.next = 63;
                      break;
                    }
                    _context.next = 63;
                    return {
                      state: 'receivedChunkMetadata',
                      chunkId: chunkId,
                      metadata: metadata
                    };
                  case 63:
                    _context.next = 67;
                    break;
                  case 65:
                    errors.push(parsedResponse.error);
                    if (parsedResponse.chunkId) {
                      failedChunkIds.push(parsedResponse.chunkId);
                    }
                  case 67:
                    _context.next = 52;
                    break;
                  case 69:
                    if (!suggestions.length) {
                      _context.next = 72;
                      break;
                    }
                    _context.next = 72;
                    return {
                      state: 'parsed',
                      suggestions: suggestions
                    };
                  case 72:
                    if (!errors.length) {
                      _context.next = 75;
                      break;
                    }
                    _context.next = 75;
                    return {
                      state: 'failed',
                      reason: 'backend',
                      errors: errors,
                      statusCode: response.status,
                      failedChunkIds: failedChunkIds
                    };
                  case 75:
                    // Keep the last (potentially incomplete) line in the lineBuffer
                    lineBuffer = lines[0];
                    _context.next = 39;
                    break;
                  case 78:
                    _context.next = 84;
                    break;
                  case 80:
                    _context.prev = 80;
                    _context.t0 = _context["catch"](34);
                    _context.next = 84;
                    return {
                      state: 'failed',
                      reason: 'parsing',
                      errors: ['parsingError'],
                      statusCode: response.status,
                      failedChunkIds: queuedChunkIds.filter(function (id) {
                        return !processedChunkIds.includes(id);
                      })
                    };
                  case 84:
                    _context.next = 95;
                    break;
                  case 86:
                    _context.prev = 86;
                    _context.t1 = _context["catch"](15);
                    if (!(_context.t1.name === 'AbortError')) {
                      _context.next = 93;
                      break;
                    }
                    _context.next = 91;
                    return {
                      state: 'failed',
                      reason: 'aborted',
                      errors: ['Streaming aborted'],
                      statusCode: _context.t1.status,
                      failedChunkIds: queuedChunkIds
                    };
                  case 91:
                    _context.next = 95;
                    break;
                  case 93:
                    _context.next = 95;
                    return {
                      state: 'failed',
                      reason: 'unhandled',
                      errors: _context.t1 instanceof Error && ['RangeError', 'TypeError', 'TransformError'].includes(_context.t1.name) ? [_context.t1.message] : ['unhandled'],
                      statusCode: _context.t1.status,
                      failedChunkIds: queuedChunkIds
                    };
                  case 95:
                  case "end":
                    return _context.stop();
                }
              }, _loop, null, [[15, 86], [34, 80]]);
            });
          case 12:
            if (!(withinLimitsParagraphChunks.length && attemptCount <= QUEUE_MAX_ADDITIONAL_ATTEMPTS)) {
              _context2.next = 19;
              break;
            }
            return _context2.delegateYield(_loop(), "t0", 14);
          case 14:
            _ret = _context2.t0;
            if (!(_ret === 0)) {
              _context2.next = 17;
              break;
            }
            return _context2.abrupt("break", 19);
          case 17:
            _context2.next = 12;
            break;
          case 19:
            /**
             * Purge any remaining valid paragraphs
             */
            if (withinLimitsParagraphChunks.length) {
              purgedChunkIds.push.apply(purgedChunkIds, _toConsumableArray(withinLimitsParagraphChunks.map(function (p) {
                return p.id;
              })));
            }
            if (!purgedChunkIds.length) {
              _context2.next = 23;
              break;
            }
            _context2.next = 23;
            return {
              state: 'purged',
              totalParts: totalParts,
              totalPurgedParts: purgedChunkIds.length,
              purgedChunkIds: purgedChunkIds
            };
          case 23:
            _context2.next = 25;
            return {
              state: 'done'
            };
          case 25:
            return _context2.abrupt("return");
          case 26:
          case "end":
            return _context2.stop();
        }
      }, _callee);
    })();
  });
  return _mdPlusSuggestionGenerator.apply(this, arguments);
}